import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();

  const mainMenuItems = [
    { path: '/dashboard', icon: '📊', label: 'Dashboard', badge: 'Overview' },
    { path: '/daily-reporting', icon: '📝', label: 'Daily Reports', badge: 'Active' },
    { path: '/cheque-reporting', icon: '💳', label: 'Cheque Reports', badge: null },
    { path: '/diwali-reporting', icon: '🎉', label: 'Diwali Reports', badge: 'Special' },
    { path: '/data-table', icon: '📑', label: 'Reports Explorer', badge: null },
  ];

  const submissionMenuItems = [
    { path: '/reports/daily', icon: '➕', label: 'New Daily Report' },
    { path: '/reports/check', icon: '➕', label: 'New Cheque Report' },
    { path: '/reports/festive', icon: '➕', label: 'New Festive Report' },
    { path: '/reports/offer', icon: '➕', label: 'New Offer Report' },
  ];

  const isLinkActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      {/* Overlay for mobile view */}
      <div
        className={`sidebar-backdrop ${isOpen ? 'show' : ''}`}
        onClick={toggleSidebar}
      />

      <aside className={`app-sidebar ${isOpen ? 'sidebar-expanded' : ''}`}>
        {/* Brand / Logo */}
        <div className="sidebar-brand">
          <div className="brand-logo-glow">
            <span className="brand-icon">🚀</span>
          </div>
          <div className="brand-text-block">
            <h1 className="brand-name">AWPL Leader</h1>
            <span className="brand-sub">Reporting Portal</span>
          </div>
          <button
            className="sidebar-close-btn"
            onClick={toggleSidebar}
            aria-label="Close sidebar"
          >
            ✕
          </button>
        </div>

        {/* Navigation Groups */}
        <div className="sidebar-nav-container">
          <div className="nav-group-heading">MAIN NAVIGATION</div>
          <Nav className="flex-column nav-group-list">
            {mainMenuItems.map((item) => {
              const active = isLinkActive(item.path);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`nav-item-link ${active ? 'active' : ''}`}
                  onClick={() => window.innerWidth <= 992 && toggleSidebar()}
                >
                  <span className="nav-item-icon">{item.icon}</span>
                  <span className="nav-item-text">{item.label}</span>
                  {item.badge && (
                    <span className={`nav-item-badge ${active ? 'badge-active' : ''}`}>
                      {item.badge}
                    </span>
                  )}
                </Link>
              );
            })}
          </Nav>

          <div className="nav-group-heading mt-4">SUBMIT FORMS</div>
          <Nav className="flex-column nav-group-list">
            {submissionMenuItems.map((item) => {
              const active = isLinkActive(item.path);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`nav-item-link ${active ? 'active' : ''}`}
                  onClick={() => window.innerWidth <= 992 && toggleSidebar()}
                >
                  <span className="nav-item-icon">{item.icon}</span>
                  <span className="nav-item-text">{item.label}</span>
                </Link>
              );
            })}
          </Nav>
        </div>

        {/* Footer info & Account widget */}
        <div className="sidebar-footer">
          <Link
            to="/profile"
            className="sidebar-user-card"
            onClick={() => window.innerWidth <= 992 && toggleSidebar()}
          >
            <div className="user-avatar-sm">👨‍💼</div>
            <div className="user-text-sm">
              <span className="user-name-sm">Leader Portal</span>
              <span className="user-status-dot">● Online</span>
            </div>
            <span className="user-arrow-sm">›</span>
          </Link>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
